import CheckCircle from '@mui/icons-material/CheckCircle';
import React from 'react';
import LineinputReact, { Component } from 'react';
import { urls } from './constants';
import { Eye, Eyeselect, Dropdown } from './svg';
import { connect } from 'react-redux';
import { backgroundColor, colors } from './helper';
import CloseIcon from '@mui/icons-material/Close';

class LineInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFocus: false,
            isBlur: true,
            inpval: '',
            hidepwd: true,
            mobileno: '',
            color: props.color || false,
            isError:false
        }
        this.ref = React.createRef();
    }

    handleChange = (e, type) => {
        let val = e.target.value;
        if (type === 'mobileno') {
            val = val.replace(/[^0-9]/gi, '')
        } else if (e.target.name === 'password') {
            val = e.target.value;
        }
        else {
            val = val.replace(/[^a-z0-9]/gi, '')
        }
        this.setState({ inpval: val })
    }
    resetInput = () => {
        this.setState({ inpval: '' });
        if (this.ref.current) {
            this.ref.current.value = '';
        }
        if (this.props.onChange) {
            const syntheticEvent = {
                target: {
                    value: '',
                    name: this.props.name,
                },
            };
            this.props.onChange(syntheticEvent);
        }
    }
    showIcon = () => {
        if (this.state.hidepwd) {
            return <Eyeselect  width="16px"/>
        } else {
            return <Eye height="16px" width="16px"/>
        }
    }
    toglePwd = () => {
        this.ref.current.type = this.ref.current.type === 'password' ? 'text' : 'password';
        this.setState({ hidepwd: !this.state.hidepwd })
    }
    render() {
        const typeid = this?.props?.stateData?.common?.selBookingType?.typeId || this?.props?.stateData?.common?.deliveybktId;
        // console.log(this.props.value, this.props.value && (this.props.value+'').length > 0, `${this.state.isFocus ? "input--label active" : this.props.value.length > 0 && this.state.isBlur  ? " input--label filled" : "input--label"}`)
        return (
            <div className={`input--content ${this.props.isError?"errorInput":""}`}>
                <input
                    ref={this.ref}
                    key={this.props.name}
                    className={this.props.disabled ? 'disable' : ''}
                    style={{ backgroundColor: this.props.disabled === false && this.state.color === true ? colors[typeid - 1] : "", textAlign: this.props.textAlign }}
                    type={this.props.type}
                    id={this.props.id}
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    onFocus={() => { this.setState({ isFocus: true, isBlur: false }) }}
                    onBlur={(e) => { this.setState({ isFocus: false, isBlur: true }); !!this.props.onBlur && this.props.onBlur(e); }}
                    onKeyPress={(e) => { !!this.props.onKeyPress && this.props.onKeyPress(e) }}
                    onKeyDown={(e) => { !!this.props.onKeyDown && this.props.onKeyDown(e) }}
                    onChange={(e) => { !this.props.disabled && this.props.onChange && this.props.onChange(e) }}
                    autoComplete="off"
                    autoFocus={this.props.autoFocus}
                    maxLength={this.props.maxLength}
                    onClick={(e) => { !!this.props.onClick && this.props.onClick(e) }}
                    checked={this.props.checked}
                />
                <div className={this.state.isFocus ? "input--label active" : (this.props.value + '').length > 0 && this.state.isBlur ? " input--label filled" : "input--label"}>{this.props.label}</div>
                {this.props.icon === 'pwd' && <div className="icon" onClick={this.toglePwd}>{this.showIcon()}</div>}
                {this.props.icon === 'chkcirle' && (this.props.value + '').length  > 0 && !this.state.isFocus && <div className="icon --chkcirle" >{<CheckCircle sx={{ color: "#14c508b0", fontSize: 26 }} />}</div>}
                {this.props.icon === 'chkActionGST' && (this.props.value + '').length  > 0 && <div className="icon --chkBtn" >{<span style={{ color: '#0086ff', textDecoration: 'underline', fontWeight: 'bold' }} onClick={() => { window.open(urls.searchTaxPayer) }}>Check</span>}</div>}
                {this.props.icon === 'drop' && <div className="icon--drop" ><Dropdown /></div>}
                {this.props.icon === 'reset' && (this.props.value + '').length  > 0 && <div className="icon --reset" onClick={this.resetInput}><CloseIcon /></div>}
            </div>
        )
    }
}
const mapStateToProps = (stateData) => ({ stateData })
export default connect(mapStateToProps)(LineInput)
// export default LineInput;

